const getModule = (mod) => typeof(mod) == 'function' ? mod : mod.default

const addDays = getModule(require('date-fns/addDays'))
const subDays = getModule(require('date-fns/subDays'))
const addCore = getModule(require('date-fns/add'))
const format = getModule(require('date-fns/format'))
const parse = getModule(require('date-fns/parse'))
const isSameDayCore = getModule(require('date-fns/isSameDay'))
const isBeforeCore = getModule(require('date-fns/isBefore'))
const isAfterCore = getModule(require('date-fns/isAfter'))
const parseISO = getModule(require('date-fns/parseISO'))
const formatISO = getModule(require('date-fns/formatISO'))
const eachDayOfInterval = getModule(require('date-fns/eachDayOfInterval'))

const getDate = (dt) => {
  if(dt instanceof Date) return dt
  if(typeof(dt) === 'string') return parseISO(dt)
  throw new Error('string or date expected for getDate')
}

const add = (dt, duration) => {
  dt = getDate(dt)
  return addCore(dt, duration)
}

const getToday = () => {
  const dt = new Date()
  dt.setHours(0)
  dt.setMinutes(0)
  dt.setSeconds(0)
  dt.setMilliseconds(0)
  return dt
}

const getFormat = seperator => ['yyyy', 'MM', 'dd'].join(seperator)
const dateToString = (date, seperator = '-') => format(date, getFormat(seperator))
const stringToDate = (url, seperator = '-') => parse(url, getFormat(seperator), new Date())

const title = (date) => format(getDate(date), 'EEE do MMM, yyyy')
const timeTitle = (date) => format(getDate(date), 'EEE do MMM, yyyy @ HH:mm')

const isSame = (compare, date) => isSameDayCore(getDate(date), getDate(compare))
const isBefore = (compare, date) => isBeforeCore(getDate(date), getDate(compare))
const isAfter = (compare, date) => isAfterCore(getDate(date), getDate(compare))

const isBeforeOrSame = (compare, date) => isSame(compare, date) || isBefore(compare, date)
const isAfterOrSame = (compare, date) => isSame(compare, date) || isAfter(compare, date)

const isDateWithinRange = (dates, date) => {
  date = getDate(date)
  if(typeof(dates) == 'string') return isSame(dates, date)
  if(dates instanceof Array) return dates.filter(singleDate => isSame(singleDate, date)).length > 0
  if(dates.from && dates.to) {
    const isDateAfterStart = isBeforeOrSame(date, dates.from)
    const isDateBeforeEnd = isAfterOrSame(date, dates.to)
    return isDateAfterStart && isDateBeforeEnd
  }
  return false
}

// days is an array like 'Mon', 'Tue', 'Wed'
const isDateWithinDays = (days, date) => {
  const dateDay = format(getDate(date), 'EEE').toLowerCase()
  return days
    .map(d => d.toLowerCase())
    .find(d => d == dateDay) ?
      true :
      false
}

const getRange = (start, end) => eachDayOfInterval({
  start: getDate(start),
  end: getDate(end),
})

module.exports = {
  getDate,
  addDays,
  subDays,
  add,
  getToday,
  format,
  parse,
  getFormat,
  dateToString,
  stringToDate,
  title,
  timeTitle,
  isSame,
  isBefore,
  isAfter,
  isBeforeOrSame,
  isAfterOrSame,
  isDateWithinRange,
  isDateWithinDays,
  getRange,
  parseISO,
  formatISO,
}